import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AlertProps } from '@urbaninfrastructure/react-ui-kit';
import Alert from '../Alert';
import graphQLErrorMessages from './messages';
import { ApolloError } from '@apollo/client';
import { GraphQLFormattedError } from 'graphql';

export type GraphQLErrorWithCode = GraphQLFormattedError & { code: string };

const ErrorAlert: FC<AlertProps> = props => {
  return (
    <Alert
      variant="error"
      data-testid="GraphQLErrorMessages__Alert"
      {...props}
    />
  );
};

export const GraphQLErrors: FC<{ error: ApolloError } & AlertProps> = ({
  error,
  ...props
}) => {
  if (error.graphQLErrors && error.graphQLErrors.length) {
    return (
      <>
        {error.graphQLErrors.map((error, i) => {
          if (!error) {
            return null;
          }
          const { code } = error as GraphQLErrorWithCode;
          const message =
            (code && graphQLErrorMessages[code]) ||
            graphQLErrorMessages.ERR_GENERIC;
          return (
            <ErrorAlert key={i} {...props}>
              <span data-testid={message.id}>
                <FormattedMessage {...message} />
              </span>
            </ErrorAlert>
          );
        })}
      </>
    );
  }

  if (error.networkError) {
    return (
      <ErrorAlert {...props}>
        <span data-testid={graphQLErrorMessages.ERR_NETWORK_ERROR.id}>
          <FormattedMessage {...graphQLErrorMessages.ERR_NETWORK_ERROR} />
        </span>
      </ErrorAlert>
    );
  }

  return (
    <ErrorAlert {...props}>
      <span data-testid={graphQLErrorMessages.ERR_GENERIC.id}>
        <FormattedMessage {...graphQLErrorMessages.ERR_GENERIC} />
      </span>
    </ErrorAlert>
  );
};
